module.exports = __webpack_public_path__ + "static/caprev-757744c32555c0cecc6be06b50f4708d.png";